// This defines status of a content progress - NOT_STARTED/IN_PROGRESS/COMPLETED"
// This enum is used by both Api data and state data.
export enum ContentProgressStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
